import React from 'react';
import './About.css';

const About = () => {
  return (
    <div style={{ 
      padding: '3rem 2rem', 
      maxWidth: '1200px', 
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif'
    }}>
      {/* Page Title */}
      <h1 style={{
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#2c5aa0',
        textAlign: 'center',
        marginBottom: '2rem'
      }}>
        About Us
      </h1>

      {/* Introductory Text */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '2.5rem',
        borderRadius: '16px',
        marginBottom: '3rem',
        border: '1px solid #e9ecef',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        <p style={{
          fontSize: '1.2rem',
          lineHeight: '1.7',
          color: '#333',
          margin: 0,
          textAlign: 'left'
        }}>
          Founded in 2024 in the heart of Europe, Luxembourg, DataFre8 brings together a global team of developers working remotely to build the future of 3D machine learning. United by a shared mission to simplify and accelerate 3D computer vision, the team combines deep technical expertise with diverse perspectives to create a powerful, user-friendly platform that breaks down barriers for innovators worldwide.
        </p>
      </div>

      {/* Main Content Sections - Grid Layout */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '2rem',
        marginBottom: '2rem'
      }}>
        
        {/* Section 1: Open Source, Shared Progress */}
        <div style={{
          backgroundColor: '#ffffff',
          padding: '2rem',
          borderRadius: '16px',
          border: '1px solid #e9ecef',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1.5rem'
          }}>
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              style={{ color: '#2c5aa0', flexShrink: 0 }}
            >
              <path d="M9 12l2 2 4-4"/>
              <path d="M21 12c-1 0-2-1-2-2s1-2 2-2 2 1 2 2-1 2-2 2z"/>
              <path d="M3 12c1 0 2-1 2-2s-1-2-2-2-2 1-2 2 1 2 2 2z"/>
              <path d="M12 3c0 1-1 2-2 2s-2-1-2-2 1-2 2-2 2 1 2 2z"/>
              <path d="M12 21c0-1 1-2 2-2s2 1 2 2-1 2-2 2-2-1-2-2z"/>
            </svg>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#2c5aa0',
              margin: 0
            }}>
              Open Source, Shared Progress
            </h2>
          </div>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0,
            flex: 1
          }}>
            At DataFre8, we believe that innovation thrives in open ecosystems. That's why we are deeply <strong>committed to open source development</strong>. By sharing tools, libraries, and research with the wider 3D machine learning community, we aim to foster transparency, collaboration, and faster progress across the industry. Whether it's contributing to existing frameworks or releasing our own modules, we see open source as a vital part of our mission to democratize access to advanced 3D vision technologies.
          </p>
        </div>

        {/* Section 2: Privacy First, by Design */}
        <div style={{
          backgroundColor: '#ffffff',
          padding: '2rem',
          borderRadius: '16px',
          border: '1px solid #e9ecef',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1.5rem'
          }}>
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              style={{ color: '#2c5aa0', flexShrink: 0 }}
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <circle cx="12" cy="16" r="1"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#2c5aa0',
              margin: 0
            }}>
              Privacy First, by Design
            </h2>
          </div>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0,
            flex: 1
          }}>
            As a European company, DataFre8 operates under some of the world's strictest data protection regulations, and we embrace that responsibility. User privacy is not just a legal requirement for us; it's a core principle. From how we design our platform to how we handle data behind the scenes, every decision is made with your privacy in mind. We go to great lengths to minimize data collection, ensure secure storage, and give users full transparency and control over their information.
          </p>
        </div>

        {/* Section 3: Free Education for a Fast-Growing Field */}
        <div style={{
          backgroundColor: '#ffffff',
          padding: '2rem',
          borderRadius: '16px',
          border: '1px solid #e9ecef',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1.5rem'
          }}>
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              style={{ color: '#2c5aa0', flexShrink: 0 }}
            >
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#2c5aa0',
              margin: 0
            }}>
              Free Education for a Fast-Growing Field
            </h2>
          </div>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0,
            flex: 1
          }}>
            3D computer vision is one of the fastest-growing fields in AI, with applications expanding rapidly across industries—from robotics and autonomous vehicles to healthcare, manufacturing, and augmented reality. As demand for 3D vision expertise rises, so does the need for accessible, high-quality learning resources. At DataFre8, our mission goes beyond building powerful, user-friendly tools, we're equally committed to making education in this field freely available to all. Whether you're a student, researcher, or developer just getting started, we aim to provide the knowledge and guidance you need to thrive in this exciting domain.
          </p>
        </div>

      </div>
    </div>
  );
};

export default About; 